import {Component, Input} from '@angular/core';
import {FacebookService} from '@core/services/facebook.service';
import {SharingService} from '@core/services/sharing.service';
import {Clipboard} from '@angular/cdk/clipboard';
import {SnackbarService} from '@core/services/snackbar.service';

export enum SharingEntityType {
  NEWS = 'news',
  VOTING = 'voting'
}

@Component({
  selector: 'app-news-sharing-buttons',
  templateUrl: './news-sharing-buttons.component.html',
  styleUrls: ['./news-sharing-buttons.component.scss']
})
export class NewsSharingButtonsComponent {

  @Input() public withoutText: boolean;
  @Input() public bottomBar: boolean;
  @Input() public sharingMenu: boolean;
  @Input() private smallScreenSize: boolean = false;
  @Input() private entityId: string;
  @Input() private type = SharingEntityType.NEWS;
  private copyClipboard: string;
  private sharingData: any;

  constructor( private sharingService: SharingService,
               private facebookService: FacebookService,
               private clipboard: Clipboard,
               private snackbarService: SnackbarService ) { }

  private get sharingInfoFunction() {
    switch (this.type) {
      case SharingEntityType.NEWS:
        return (id) => this.sharingService.fetchNewsEntrySharingInfo(id);
      case SharingEntityType.VOTING:
        return (id) => this.sharingService.fetchVotingSharingInfo(id);
    }
  }

  public get sharingText() {
    switch (this.type) {
      case SharingEntityType.NEWS:
        return 'Beitrag teilen';
      case SharingEntityType.VOTING:
        return 'Abstimmung teilen';
    }
  }

  private async getSharingLink() {
    try {
      if (!this.sharingData) {
        this.sharingData = await this.sharingInfoFunction(this.entityId);
      }
      return this.sharingData.content_url;
    } catch (e) {
      throw (e);
    }
  }

  public async onCopyLink(event) {
    event.preventDefault();
    await this.getSharingLink().then(url => {
      this.copyClipboard = url;
    });
    const pending = this.clipboard.beginCopy(this.copyClipboard);
    setTimeout(() => {
      const successfullyCopied = pending.copy();
      if (successfullyCopied) {
        this.snackbarService.showSimpleSnackbar('Link wurde kopiert');
      } else {
        pending.destroy();
      }
    }, 0);
  }

  public shareOnWhatsApp(e) {
    e.preventDefault();
    const win = window.open('about:blank', '_blank');

    this.getSharingLink().then(url => {
      win.location.href = `https://wa.me/?text=${encodeURIComponent(url)}`;
    });
  }

  public shareOnTwitter(e) {
    e.preventDefault();
    const win = window.open('about:blank', '_blank');

    this.getSharingLink().then(url => {
      win.location.href = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`;
    });
  }

  public async shareOnFacebook(e) {
    e.preventDefault();
    const win = window.open('about:blank', '_blank');

    this.getSharingLink().then(url => {
      win.location.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    });
  }

  public shareOnFacebookViaPrivateMessage(e) {
    e.preventDefault();

    if (this.smallScreenSize) {
      const win = window.open('about:blank', '_blank');

      this.getSharingLink().then(url => {
        win.location.href = 'fb-messenger://share?link=' + encodeURIComponent(url) + '&app_id=' +
          encodeURIComponent(this.facebookService.getAppID());
      });
    } else {
      this.getSharingLink().then(url => {
        this.facebookService.sendPrivateMessage(url);
      });
    }
  }
}
